import React from "react";
import { OrderHistoryBody } from "tsi-common-react/src/apps/customer-account/OrderHistoryBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.OrderHistoryDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <OrderHistoryBody {...props} />
    </PageSkeleton>
);
